import React, { useState, useEffect } from "react"
import * as Constants from '../../utils/constants'
import { getRichiesteRimborsoInserite } from "../../services/endpoints";
import { isPresentAuthenticatedUser } from "../../utils/utilities";
import { showProgress } from "../../utils/elements";
import {
  Container,
  Button,
  Row,
  Col,
  Badge,
  Card,
  CardBody,
  CardTitle,
  CardText
} from 'design-react-kit';

export const SibaMostraSceltaRimborso = (props) => {

  const [isLoading, setLoading] = useState(true);
  const [numeroRichiesteRimborso, setNumeroRichiesteRimborso] = useState(0)

  useEffect(() => {
    async function fetchData() {
      if (isPresentAuthenticatedUser()) {
        let utente = sessionStorage.getItem(Constants.USER_IN_SESSION)
        const richiesteRimborsi = await getRichiesteRimborsoInserite(utente);
        if (richiesteRimborsi !== undefined && richiesteRimborsi.length > 0) {
          setNumeroRichiesteRimborso(richiesteRimborsi.length);
        }
      }
      setLoading(false)
    }
    fetchData();
  }, []);

  const onClickElencoRichieste = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_ELENCORICHIESTE);
    props.handleNext();
  }

  const onClickElencoVeicoli = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI);
    props.handleNext();
  }

  const onClickCiclomotori = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI);
    props.handleNext();
  }

  const onClickFuoriRegione = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_FUORIREGIONE);
    props.handleNext();
  }
  
  const onClickVeicoloAziendaleFuoriRegione = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE);
    props.handleNext();
  }

  const onClickEredi = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_EREDI);
    props.handleNext();    
  } 

  const onClickLeasing = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_LEASING);
    props.handleNext();    
  } 

  const onClickIntermediari = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI);
    props.handleNext();
  }

  const onClickVeicoloAziendale = () => {
    props.handleChoice(Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE);
    props.handleNext();
  }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="sceltaRimborso" tag="section" >
      <Container className="my-4" id="sceltaRimborso1" tag="section" >
        <h5>Persona fisica: <br />{sessionStorage.getItem(Constants.USER_IN_SESSION)}</h5>
        <div className="my-2 px-2 btn-group-vertical">
          {numeroRichiesteRimborso > 0 ? (
            <Button className="btn btn-primary my-2" color="primary" icon={false} tag="button" onClick={onClickElencoRichieste}>
              Consulta richieste inserite&nbsp;&nbsp;
              <Badge color='light'>{numeroRichiesteRimborso}</Badge>
            </Button>) : (React.Fragment)
          }
          <br />
          <Row>
          <Col xs='12' lg='6'>
              <Card  spacing className='card-bg card-big'>
                <CardBody>
                  {/* STALIGK-821	: aggiunta classe btn-rimborsi x larghezza = buttons */}
                  <CardTitle><strong><i>Rimborsi per Residenti in Liguria</i></strong></CardTitle>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickElencoVeicoli}>
                    Rimborso per auto o moto
                  </Button>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickCiclomotori}>
                    Rimborso per ciclomotore o Quad.Leggero
                  </Button>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickVeicoloAziendale}>
                    Rimborso per auto o moto aziendale registrato 
                  </Button>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickEredi}>
                    Rimborso per erede
                  </Button>
                  <br/>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickLeasing}>
                    Rimborso per veicoli leasing
                  </Button>
                  <Button className="btn btn-primary btn-rimborsi mb-3" color="primary" icon={false} tag="button" onClick={onClickIntermediari}>
                    Rimborso per intermediario della riscossione
                    </Button>
                </CardBody>
              </Card>
            </Col>
            <Col xs='12' lg='6'>
             <Card  spacing className='card-bg card-big'>
                <CardBody>
                    <CardTitle><strong><i>Rimborsi per Residenti fuori Liguria</i></strong></CardTitle>
                    <Button className="btn btn-primary btn-rimborsi mb-2" color="primary" icon={false} tag="button" onClick={onClickFuoriRegione}>
                      Rimborso per auto o moto ligure
                    </Button>
                     {/* STALIGK-793: aggiunto button veicoli aziendali fuori regione : ATTUALMENTE COMMENTATO 
                    <Button className="btn btn-primary btn-rimborsi mb-2" color="primary" icon={false} tag="button" onClick={onClickVeicoloAziendaleFuoriRegione}>
                    Rimborso per veicolo aziendale ligure
                    </Button> */}
                    <Button className="btn btn-primary btn-rimborsi mb-2" color="primary" icon={false} tag="button" onClick={onClickIntermediari}>
                    Rimborso per intermediario della riscossione
                     </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <br />
          <br />
          </div>
      </Container>

      <Container className="px-2 my-2" id="stepper-nav" tag="div">
        <Row>
          <Col>
            <div className="btn-toolbar justify-content-between" role="toolbar">
              <div className="btn-group mr-2">
                <Button
                  className="btn btn-outline-primary"
                  icon={false}
                  size="sm"
                  tag='a'
                  href={Constants.URL_TASSAAUTO_SERVIZI_ONLINE}
                  role='button'
                > {Constants.STR_BUTTON_RESET}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default SibaMostraSceltaRimborso;